/* ============================================================================
   KDF · Panier global (Kosher Deli Food)
   - Source unique : localStorage "kdf_cart"
   - Article : { qty, name, price, perkg, fmt, img }
   - Émet l'événement "kdfc:cart" {count,total}  -> la bulle du header se met à jour
   - Écoute "kdfc:open-cart"                      -> ouvre le tiroir (clic icône header)
   - Possède le tiroir panier (récap éditable + Commander sur WhatsApp)
   Chargé globalement via layout/theme.liquid -> disponible sur TOUTES les pages.
   ============================================================================ */
(function(){
  var KEY = 'kdf_cart';
  var PHONE = String(window.KDF_PHONE || '66655186810');
  var I18N = (window.KDF_I18N && window.KDF_I18N.cart) || {};
  var RTL = !!(window.KDF_I18N && window.KDF_I18N.rtl);
  function t(k, fb){ return (I18N[k] != null && I18N[k] !== '') ? I18N[k] : fb; }

  function money(n){ return '฿' + Number(n || 0).toLocaleString('en-US'); }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(m){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m]; }); }

  function read(){ try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch(e){ return {}; } }
  function write(c){ try { localStorage.setItem(KEY, JSON.stringify(c)); } catch(e){} }

  function count(){ var c = read(), n = 0; for(var k in c){ n += c[k].qty || 0; } return n; }
  /* ---- vente au poids ---- */
  function vpRate(it){ return (it.vpunit === '100g') ? (it.price || 0) / 10 : (it.price || 0); }
  function vpUnitLabel(it){ return (it.vpunit === '100g') ? t('per_100g', '/ 100 g') : t('per_kg', '/ kg'); }
  function vpFmtKg(kg){ var s = (kg % 1 === 0) ? String(kg) : kg.toFixed(1).replace('.', ','); return s + ' kg'; }
  function vpQtyLabel(it){
    if(it.vpmode === 'piece'){ return (it.qty || 0) + ' ' + ((it.qty || 0) > 1 ? t('pieces', 'pièces') : t('piece', 'pièce')); }
    if(it.vpmode === 'kg'){ return vpFmtKg(((it.qty || 0) * (it.vpstep || 0)) / 1000); }
    if(it.vpmode === 'g'){ return ((it.qty || 0) * (it.vpstep || 0)) + ' g'; }
    return null;
  }
  function vpLineTotal(it){
    if(it.vpmode === 'piece') return null;
    if(it.vpmode === 'kg' || it.vpmode === 'g') return ((it.qty || 0) * (it.vpstep || 0)) / 1000 * (it.price || 0);
    return (it.qty || 0) * (it.price || 0);
  }
  function total(){ var c = read(), t = 0; for(var k in c){ var lt = vpLineTotal(c[k]); if(lt != null) t += lt; } return t; }

  function notify(){
    document.dispatchEvent(new CustomEvent('kdfc:cart', { detail: { count: count(), total: total() } }));
    render();
  }

  function add(item){
    if(!item || item.id == null) return;
    var c = read(), id = String(item.id);
    if(!c[id]) c[id] = { qty: 0, name: item.name || '', price: Number(item.price) || 0, perkg: !!item.perkg, fmt: item.fmt || '', img: item.img || '', vpmode: item.vpmode || '', vpstep: Number(item.vpstep) || 0, vpunit: item.vpunit || '' };
    c[id].qty += (item.qty != null ? item.qty : 1);
    if(c[id].qty <= 0) delete c[id];
    write(c); notify();
  }
  function setQty(id, q){
    var c = read(); id = String(id);
    if(!c[id]) return;
    c[id].qty = q;
    if(c[id].qty <= 0) delete c[id];
    write(c); notify();
  }
  function remove(id){ var c = read(); delete c[String(id)]; write(c); notify(); }
  function clear(){ write({}); notify(); }

  /* -------------------------------- tiroir -------------------------------- */
  var SEAL = '<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="32" fill="none" stroke="#C9A961" stroke-width="3"/><text x="50" y="63" text-anchor="middle" font-family="Georgia, serif" font-size="38" font-weight="600" fill="#C9A961">K</text></svg>';
  var wrap, itemsEl, totalEl, footEl, overlay, panel, built = false;

  var CSS = ''+
  '.kdfcart{font-family:"Inter",system-ui,sans-serif;}'+
  '.kdfcart *{box-sizing:border-box;}'+
  '.kdfcart-ov{position:fixed;inset:0;background:rgba(12,10,7,.5);opacity:0;pointer-events:none;transition:opacity .28s;z-index:1000;}'+
  '.kdfcart.show .kdfcart-ov{opacity:1;pointer-events:auto;}'+
  '.kdfcart-panel{position:fixed;left:0;right:0;bottom:0;z-index:1001;background:#FBF8F2;border-radius:22px 22px 0 0;transform:translateY(110%);transition:transform .3s cubic-bezier(.22,1,.36,1);max-height:86%;display:flex;flex-direction:column;box-shadow:0 -10px 40px rgba(12,10,7,.25);max-width:560px;margin:0 auto;}'+
  '.kdfcart.show .kdfcart-panel{transform:translateY(0);}'+
  '.kdfcart-head{display:flex;align-items:center;justify-content:space-between;padding:18px 20px 12px;border-bottom:1px solid rgba(22,19,15,.12);}'+
  '.kdfcart-head b{font-family:"Fraunces",Georgia,serif;font-weight:600;font-size:19px;color:#16130F;}'+
  '.kdfcart-head button{border:none;background:none;font-size:20px;line-height:1;color:#8a8175;cursor:pointer;padding:4px 6px;}'+
  '.kdfcart-items{overflow:auto;padding:8px 20px;flex:1;min-height:90px;}'+
  '.kdfcart-empty{text-align:center;color:#8a8175;font-size:14px;padding:34px 0;}'+
  '.kdfcart-item{display:flex;align-items:center;gap:12px;padding:12px 0;border-bottom:1px solid rgba(22,19,15,.08);}'+
  '.kdfcart-mini{width:54px;height:54px;border-radius:11px;background:#F7F1E4;flex:none;display:flex;align-items:center;justify-content:center;overflow:hidden;}'+
  '.kdfcart-mini img{width:100%;height:100%;object-fit:cover;}'+
  '.kdfcart-mini svg{width:60%;height:60%;}'+
  '.kdfcart-info{flex:1;min-width:0;}'+
  '.kdfcart-info b{display:block;font-size:13.5px;font-weight:600;color:#16130F;line-height:1.25;}'+
  '.kdfcart-info small{display:block;font-size:11.5px;color:#8a8175;margin-top:2px;}'+
  '.kdfcart-step{display:flex;align-items:center;background:#16130F;border-radius:10px;color:#F7F1E4;height:34px;flex:none;}'+
  '.kdfcart-step button{width:30px;height:34px;border:none;background:none;color:#F7F1E4;font-size:17px;cursor:pointer;display:flex;align-items:center;justify-content:center;}'+
  '.kdfcart-step b{min-width:20px;text-align:center;font-size:13px;font-weight:700;}'+
  '.kdfcart-foot{padding:14px 20px calc(env(safe-area-inset-bottom,0px) + 18px);border-top:1px solid rgba(22,19,15,.12);background:#F7F1E4;}'+
  '.kdfcart-total{display:flex;align-items:baseline;justify-content:space-between;margin-bottom:12px;}'+
  '.kdfcart-total span{font-size:12.5px;color:#8a8175;}'+
  '.kdfcart-total b{font-family:"Fraunces",Georgia,serif;font-weight:600;font-size:22px;color:#16130F;}'+
  '.kdfcart-wa{width:100%;display:flex;align-items:center;justify-content:center;gap:9px;height:52px;border:none;border-radius:13px;background:#1e7a45;color:#fff;font-family:inherit;font-weight:600;font-size:15px;cursor:pointer;transition:background .2s, transform .12s;}'+
  '.kdfcart-wa:hover{background:#1a6a3c;}'+
  '.kdfcart-wa:active{transform:translateY(1px);}'+
  '.kdfcart-note{font-size:10.5px;color:#8a8175;text-align:center;margin:9px 0 0;}';

  function build(){
    if(built) return; built = true;
    var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);
    wrap = document.createElement('div');
    wrap.className = 'kdfcart';
    wrap.dir = RTL ? 'rtl' : 'ltr';
    wrap.innerHTML =
      '<div class="kdfcart-ov" data-ov></div>'+
      '<aside class="kdfcart-panel" role="dialog" aria-label="'+esc(t('drawer_aria','Panier'))+'">'+
        '<div class="kdfcart-head"><b>'+esc(t('title','Mon panier'))+'</b><button data-x type="button" aria-label="'+esc(t('close','Fermer'))+'">&#10005;</button></div>'+
        '<div class="kdfcart-items" data-items></div>'+
        '<div class="kdfcart-foot" data-foot hidden>'+
          '<div class="kdfcart-total"><span>'+esc(t('total_label','Total indicatif'))+'</span><b data-total>฿0</b></div>'+
          '<button class="kdfcart-wa" data-wa type="button">'+
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M17.5 14.4c-.3-.15-1.8-.9-2.07-1-.27-.1-.47-.15-.67.15-.2.3-.77 1-.95 1.2-.17.2-.35.22-.65.07-.3-.15-1.27-.47-2.42-1.5-.9-.8-1.5-1.78-1.67-2.08-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.6-.92-2.2-.24-.58-.49-.5-.67-.5h-.57c-.2 0-.52.07-.8.37-.27.3-1.05 1.02-1.05 2.47s1.07 2.86 1.22 3.06c.15.2 2.1 3.2 5.08 4.49.71.3 1.26.48 1.69.62.71.22 1.36.2 1.87.12.57-.08 1.8-.73 2.05-1.44.25-.7.25-1.3.17-1.43-.07-.13-.27-.2-.57-.35z"/><path d="M12 2a10 10 0 00-8.5 15.3L2 22l4.8-1.5A10 10 0 1012 2zm0 18.2c-1.5 0-3-.4-4.3-1.16l-.3-.18-3 .94.95-2.92-.2-.3A8.2 8.2 0 1112 20.2z"/></svg>'+
            esc(t('checkout_wa','Commander sur WhatsApp'))+'</button>'+
          '<p class="kdfcart-note">'+esc(t('weight_note','Estimation — ajustée avec vous par message selon notre stock.'))+'</p>'+
        '</div>'+
      '</aside>';
    document.body.appendChild(wrap);
    overlay = wrap.querySelector('[data-ov]');
    panel   = wrap.querySelector('.kdfcart-panel');
    itemsEl = wrap.querySelector('[data-items]');
    totalEl = wrap.querySelector('[data-total]');
    footEl  = wrap.querySelector('[data-foot]');
    overlay.addEventListener('click', close);
    wrap.querySelector('[data-x]').addEventListener('click', close);
    wrap.querySelector('[data-wa]').addEventListener('click', whatsapp);
    render();
  }

  function render(){
    if(!built) return;
    var c = read(), keys = Object.keys(c);
    if(!keys.length){
      itemsEl.innerHTML = '<p class="kdfcart-empty">'+esc(t('empty','Votre panier est vide.'))+'</p>';
      footEl.hidden = true;
    } else {
      footEl.hidden = false;
      itemsEl.innerHTML = keys.map(function(id){
        var it = c[id];
        var thumb = it.img ? '<img src="'+esc(it.img)+'" alt="">' : SEAL;
        var qlabel = vpQtyLabel(it), sub;
        if(qlabel != null){
          var lt = vpLineTotal(it);
          sub = money(vpRate(it)) + ' ' + vpUnitLabel(it) + ' · ' + qlabel + (lt != null ? (' · ≈ ' + money(Math.round(lt))) : (' · ' + t('estimate', 'estimation')));
        } else {
          sub = money(it.price) + (it.fmt ? (' · ' + esc(it.fmt)) : '');
        }
        return '<div class="kdfcart-item"><div class="kdfcart-mini">'+thumb+'</div>'+
          '<div class="kdfcart-info"><b>'+esc(it.name)+'</b><small>'+sub+'</small></div>'+
          '<div class="kdfcart-step"><button data-dec="'+esc(id)+'" type="button">&minus;</button><b>'+(qlabel != null ? qlabel : it.qty)+'</b><button data-inc="'+esc(id)+'" type="button">+</button></div></div>';
      }).join('');
      itemsEl.querySelectorAll('[data-inc]').forEach(function(b){
        b.addEventListener('click', function(){ var it = read()[b.dataset.inc]; if(it) setQty(b.dataset.inc, it.qty + 1); });
      });
      itemsEl.querySelectorAll('[data-dec]').forEach(function(b){
        b.addEventListener('click', function(){ var it = read()[b.dataset.dec]; if(it) setQty(b.dataset.dec, it.qty - 1); });
      });
    }
    totalEl.textContent = money(total());
  }

  function open(){ build(); requestAnimationFrame(function(){ wrap.classList.add('show'); }); }
  function close(){ if(wrap) wrap.classList.remove('show'); }

  function whatsapp(){
    var c = read(), keys = Object.keys(c);
    if(!keys.length) return;
    var lines = keys.map(function(id){
      var it = c[id];
      var qlabel = vpQtyLabel(it);
      if(qlabel != null){
        var lt = vpLineTotal(it);
        return '• ' + qlabel + ' · ' + it.name + ' (' + money(vpRate(it)) + ' ' + vpUnitLabel(it) + (lt != null ? (' · ≈ ' + money(Math.round(lt))) : '') + ')';
      }
      return '• ' + it.qty + '× ' + it.name + ' (' + money(it.price) + ')';
    });
    var msg = t('wa_greeting','Bonjour Kosher Deli Food 👋') + '\n' + t('wa_order_intro','Je souhaite commander :') + '\n' + lines.join('\n') +
              '\n\n' + t('total_label','Total indicatif') + ' : ' + money(total()) + '\n(' + t('weight_note','Estimation — ajustée avec vous par message selon notre stock.') + ')';
    window.open('https://wa.me/' + PHONE + '?text=' + encodeURIComponent(msg), '_blank');
  }

  /* API publique */
  window.KDFCart = {
    get: read, add: add, setQty: setQty, remove: remove,
    count: count, total: total, clear: clear,
    open: open, close: close, money: money
  };

  /* l'icône panier du header émet "kdfc:open-cart" -> on ouvre le tiroir */
  document.addEventListener('kdfc:open-cart', open);

  /* au chargement : on construit le tiroir + on prévient la bulle du header */
  function init(){ build(); notify(); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
